module.exports = __webpack_public_path__ + "img/support.f9e3e55.svg";